import React from 'react';
import { useState } from 'react'
import { battery_faulty, battery_normal, grid_faulty, grid_normal, pv_faulty, pv_normal, triangle } from '../../Images/Icons';
import 'react-spring-bottom-sheet/dist/style.css';
import plants from './plants.json';

const PlantManagementCoachMark = ({onCheckChange, onSelectPlant, onChangePlant}) => {
    const [state, setNewState] = useState({ showPoup: false });

    const setState = data => {
        setNewState(prevState => ({ ...prevState, ...data }));
    }

    const showPopupAlarm = () => {
        console.log('Invoked');
        setState({ showPoup: true });
        setTimeout(() => {
            setState({ showPoup: false });
        }, 3000);
    }

    const renderDonut = (critical, major, minor, warning) => {
        const total = critical + major + minor + warning;
        const criticalDeg = (360 * (critical / total));
        const majorDeg = (360 * (major / total));
        const minorDeg = (360 * (minor / total));
        const warningDeg = (360 * (warning / total));


        return (<div style={{ width: 100, height: 100, position: "relative", border: 'solid 0px #dedede', borderRadius: '50%' }}>
            {/* { Critical } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: 'rotate(0deg)' }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#F62C42', transform: `rotate(${criticalDeg}deg)` }}></div>
            </div>
            {/* { Major } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${criticalDeg}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#FF8438', transform: `rotate(${majorDeg}deg)` }}></div>
            </div>
            {/* { Minor } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${(criticalDeg + majorDeg)}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#FDD020', transform: `rotate(${minorDeg}deg)` }}></div>
            </div>
            {/* { Warning } */}
            <div style={{ width: '100%', height: '100%', position: 'absolute', clip: 'rect(0px, 100px, 100px, 50px)', transform: `rotate(${(criticalDeg + majorDeg + minorDeg)}deg)` }}>
                <div style={{ width: '100%', height: '100%', clip: 'rect(0px, 50px, 100px, 0px)', position: 'absolute', borderRadius: '50%', background: '#69aff4', transform: `rotate(${warningDeg}deg)` }}></div>
            </div>
            <div style={{
                width: 80, height: 80, position: 'absolute', background: '#F2F5FA', top: 0, right: 0, bottom: 0, left: 0, borderRadius: '50%', margin: 'auto',
                display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', fontSize: 10, fontWeight: 400, color: '#79808F'
            }}>
                <div style={{ fontSize: 18, fontWeight: 500, color: '#292929' }}>6</div>
                Total Alarms
            </div>
        </div>);
    }

    const {showPoup} = state;

    return (
        <div style={{ margin: 20, width: '100%', height:'360px' }}>
            <div style={{ height: 'auto', marginRight: 40, marginTop: 30, padding: 10, border: 'solid 0px', background:'#FFFAE8', textAlign:'center', borderRadius:'12px', fontSize:'12px' }}>
                ⚠️<br/>
                We've detected an alarm at your plant.<br/> For help, contact our professional team at  <br/><u style={{fontWeight:'bold'}}><a href="mailto:maintenance.energy@modena.com">maintenance.energy@modena.com</a></u><br/>
                We'll respond within 24 hours.
            </div> 
            <div style={{ height: 320, marginRight: 40, marginTop: 30, padding: 0, border: 'solid 0px', }}>
                <div style={{
                    height: 36, borderRadius: 18,
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#F1F1F1', padding: '6px 16px'
                }}>
                    <input type="text" name="search-plant" placeholder='Enter Plant Name' onChange={onCheckChange}
                        style={{ flex: 1, outline: 'none', border: 'none', marginRight: 10, background: '#F1F1F1', fontSize: 14 }} />
                    <span className='fi fi-rr-search' style={{ marginTop: 6 }}></span>
                </div>
                <div style={{ height: 220, overflowY: 'scroll', marginTop: 20 }}>
                    {plants.map((plant, i) => (
                        <div onClick={onSelectPlant(plant)} key={`plants-${i}`} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 10 }}>
                            <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                <div style={{ width: 44, marginLeft: 4 }}>
                                    <input class="form-check-input" type="radio" checked={plant.id == 1} name={`check-${plant.id}`} id={`check-${plant.id}`} style={{ borderColor: '#E0E3E9' }} />
                                </div>
                                <div>
                                    <div style={{ fontSize: 14, fontWeight: 500, color: '#393D45', display: 'flex', justifyContent: 'space-between' }}>
                                        <span>{plant.name} | {plant.capacity}</span>
                                        <div style={{
                                            width: 50, height: 20, background: plant.status == 'Faulty' ? '#FFEFEC' : '#E5F6E5',
                                            color: plant.status == 'Faulty' ? '#FF1D19' : '#3B9D3F', borderRadius: 8, display: 'flex', justifyContent: 'center',
                                            alignItems: 'center', fontSize: 10, fontWeight: 700
                                        }}>{plant.status}</div>
                                    </div>
                                    <div style={{ fontSize: 12, fontWeight: 400, color: '#8F8F8F' }}>{plant.address}</div>
                                    <div style={{ display: 'flex', alignItems: 'center', fontSize: 10, fontWeight: 500, marginTop: 6, marginBottom: 6, color: plant.status == 'Faulty' ? '#FF1D19' : '#8F8F8F' }}>
                                        <img src={plant.status == 'Faulty' ? pv_faulty : pv_normal} alt="" style={{ marginRight: 4 }} />
                                        <span>{plant.pv}</span>
                                        <img src={plant.status == 'Faulty' ? grid_faulty : grid_normal} alt="" style={{ marginLeft: 10, marginRight: 4 }} />
                                        <span>{plant.grid}</span>
                                        <img src={plant.status == 'Faulty' ? battery_faulty : battery_normal} alt="" style={{ marginLeft: 10, marginRight: 4 }} />
                                        <span>{plant.battery}</span>
                                    </div>
                                </div>
                            </div>
                            <div style={{ height: 1, width: '100%', background: '#dedede', marginTop: 12, marginBottom: 12 }}></div>
                        </div>))}
                </div>
                <div onClick={onChangePlant} style={{
                    height: 44, marginTop: 20, borderRadius: 8, background: '#2DFBB5', display: 'flex', justifyContent: 'center', alignItems: 'center',
                    fontSize: 16, fontWeight: 700, color: '#292929', cursor: 'pointer'
                }}>
                    Change Plant
                </div>
            </div>
        </div>
    )
}

export default PlantManagementCoachMark